import {Component} from '@angular/core';

@Component({
  selector: 'micro-mail-message-log-outgoing',
  templateUrl: './mail-message-log-outgoing.component.html'
})
export class MailMessageLogOutgoingComponent {

}
